<template>
  <el-popover
    v-model="visible"
    placement="bottom-end"
    width="280"
    trigger="click"
    popper-class="theme-switcher-popper"
  >
    <div class="theme-switcher-panel">
      <div class="theme-switcher-panel__label">主题颜色</div>
      <div class="theme-switcher-panel__colors">
        <el-tooltip
          v-for="item in colorThemes"
          :key="item.id"
          :content="item.label + ' · ' + item.desc"
          placement="top"
        >
          <span
            class="theme-switcher-panel__swatch"
            :class="{ 'is-active': colorId === item.id }"
            :style="{ backgroundColor: item.primary }"
            @click="onColor(item.id)"
          />
        </el-tooltip>
      </div>

      <div class="theme-switcher-panel__label">显示模式</div>
      <div class="theme-switcher-panel__modes">
        <div
          v-for="item in appearanceModes"
          :key="item.id"
          class="theme-switcher-panel__mode"
          :class="{ 'is-active': modeId === item.id }"
          @click="onMode(item.id)"
        >
          <i :class="item.icon" />
          <span>{{ item.label }}</span>
          <span class="theme-switcher-panel__mode-desc">{{ item.desc }}</span>
        </div>
      </div>
    </div>

    <span slot="reference" class="theme-switcher__trigger" title="主题颜色">
      <i :class="currentMode.icon || 'el-icon-brush'" />
      <span>主题</span>
    </span>
  </el-popover>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'ThemeSwitcher',
  data() {
    return { visible: false }
  },
  computed: {
    ...mapState('appTheme', ['colorId', 'modeId']),
    ...mapGetters('appTheme', ['colorThemes', 'appearanceModes', 'currentMode'])
  },
  methods: {
    ...mapActions('appTheme', ['setColor', 'setMode']),
    onColor(id) {
      this.setColor(id)
    },
    onMode(id) {
      this.setMode(id)
    }
  }
}
</script>
